import type { LucideIcon } from 'lucide-react'
import { Inbox } from 'lucide-react'

export type EmptyStateVariant = 'page' | 'section'

interface EmptyStateProps {
  title: string
  message?: string
  icon?: LucideIcon
  variant?: EmptyStateVariant
  actionLabel?: string
  onAction?: () => void
}

const PADDING_BY_VARIANT: Record<EmptyStateVariant, string> = {
  page: 'p-12',
  section: 'p-6',
}

const ICON_SIZE_BY_VARIANT: Record<EmptyStateVariant, string> = {
  page: 'h-10 w-10',
  section: 'h-7 w-7',
}

const TITLE_SIZE_BY_VARIANT: Record<EmptyStateVariant, string> = {
  page: 'text-base',
  section: 'text-sm',
}

export function EmptyState({
  title,
  message,
  icon: Icon = Inbox,
  variant = 'page',
  actionLabel,
  onAction,
}: EmptyStateProps): JSX.Element {
  return (
    <div
      role="status"
      className={`flex flex-1 flex-col items-center justify-center rounded-lg border border-dashed border-gray-200 bg-white text-center ${PADDING_BY_VARIANT[variant]}`}
    >
      <Icon className={`mb-3 text-gray-300 ${ICON_SIZE_BY_VARIANT[variant]}`} aria-hidden />
      <p className={`font-semibold text-gray-700 ${TITLE_SIZE_BY_VARIANT[variant]}`}>{title}</p>
      {message && <p className="mt-1 max-w-md text-sm text-gray-500">{message}</p>}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-4 rounded-lg bg-brand-green px-4 py-2 text-sm font-semibold text-white hover:opacity-90"
        >
          {actionLabel}
        </button>
      )}
    </div>
  )
}
